import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'assess-root',
  template: '<router-outlet assessNewRelicAppMeta assessHydra></router-outlet>',
  styles: [':host { display: block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
